import React from "react";
import { Alert } from "@mui/material";
import { useOrgAdminAccess } from "hooks/useOrgAdminAccess";

/**
 * Wraps AdminRoutes-only pages that must remain org-admin accessible after
 * FDE-DC users mount AdminRoutes.
 */
export function OrgAdminGate({ children }) {
  const { canAccess } = useOrgAdminAccess();
  if (!canAccess) {
    return (
      <Alert severity="warning">
        This page is available to organization admins only.
      </Alert>
    );
  }
  return children;
}

export default OrgAdminGate;
